import { defineMessages } from "react-intl";

/**
 * SFCC-11723 — i18n message catalog for the goal/module LearningCenterBreadcrumb
 * block. The trail builder (`trail.ts`) stays framework-free and is fed the
 * already-formatted label strings from the component, so the static crumbs
 * ("Home", the HSA-specific "HSA Learning Center") and the templated "Goal:" /
 * "Level N: Module M" crumbs are all message-keyed and per-site overridable.
 */
const messages = defineMessages({
  home: {
    id: "learningCenter.breadcrumb.home",
    defaultMessage: "Home",
  },
  learningCenter: {
    id: "learningCenter.breadcrumb.learning_center",
    defaultMessage: "HSA Learning Center",
  },
  goalLabel: {
    id: "learningCenter.breadcrumb.goal_label",
    defaultMessage: "Goal: {title}",
  },
  levelModuleLabel: {
    id: "learningCenter.breadcrumb.level_module_label",
    defaultMessage: "Level {level}: Module {module}",
  },
});

export default messages;
